/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-04 14:47:47                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-17 14:57:34                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * Event: event display component
*/

/* Imports */
import React from "react";
import { useTranslation } from "react-i18next";
/***/

/* Components */
/***/

/* Styles */
import "./CalendarToolBar.scss";
import {
  ArrowLeftIcon,
  ArrowRightIcon
} from "@heroicons/react/24/outline";
import Loading from "../../../../../components/loading/Loading";
import { Badge, IconButton, Tooltip } from "@material-tailwind/react";
import { CalendarIcon, UserPlusIcon } from "@heroicons/react/24/solid";
/***/
/**
* Event: event display component
* @param view - actual view
* @param className - additional class name 
*/
export default function CalendarToolBar(props: any) {
  const { t } = useTranslation();
  const { 
    label, 
    view, 
    onView, 
    onNavigate, 
    loading, 
    unscheduledWorkordersLength, 
    unasignedWorkordersLength, 
    drawerType, 
    setDrawerType,
    filterDrawerComponent,
    filterBadgesComponent
  } = props;

  const goToView = (view: string) => {
    onView(view);
  };

  const goToBack = () => {
    onNavigate("PREV");
  };
  const goToNext = () => {
    onNavigate("NEXT");
  };

  return (
    <div  className="flex flex-col">
      <div className="calendar-toolbar flex">
        <div className="rbc-toolbar">

          <div className="rbc-btn-nav">
            <button type="button" onClick={() => goToBack()}><ArrowLeftIcon /></button>
            <button type="button" onClick={() => goToNext()}><ArrowRightIcon /></button>
          </div>

          <div className="rbc-toolbar-label">{label} {loading === true && <Loading />}</div>
          
          <div className="rbc-btn-view">
            <button className={view === "month" ? "active" : ""} type="button" onClick={() => goToView("month")}>{t("common:calendarViews.month")}</button>
            <button className={view === "week" ? "active" : ""} type="button" onClick={() => goToView("week")}>{t("common:calendarViews.week")}</button>
            <button className={view === "work_week" ? "active" : ""} type="button" onClick={() => goToView("work_week")}>{t("common:calendarViews.workWeek")}</button>
            <button className={view === "day" ? "active" : ""} type="button" onClick={() => goToView("day")}>{t("common:calendarViews.day")}</button>
          </div>
        </div>
        <div className="planning-toolbar">
          {filterDrawerComponent && filterDrawerComponent}
          <Tooltip content={t("planification:calendar:unscheluded:label")}>
            <IconButton className="!overflow-visible"
                        color={drawerType === "unscheluded" ? "blue" : "white"}
                        size="md"
                        onClick={() => setDrawerType(drawerType === "unscheluded" ? null : "unscheluded")}>
              <Badge invisible={unscheduledWorkordersLength === 0} withBorder className="badge"
              content={unscheduledWorkordersLength < 10 ? unscheduledWorkordersLength : "9+"}>
                <CalendarIcon className="w-6"/>
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip content={t("planification:calendar:unasigned:label")}>
            <IconButton className="!overflow-visible"
                        color={drawerType === "unasigned" ? "blue" : "white"}
                        size="md"
                        onClick={() => setDrawerType(drawerType === "unasigned" ? null : "unasigned")}>
              <Badge invisible={unasignedWorkordersLength === 0} withBorder className="badge"
              content={unasignedWorkordersLength < 10 ? unasignedWorkordersLength : "9+"}>
                <UserPlusIcon className="w-6"/>
              </Badge>
            </IconButton>
          </Tooltip>
        </div>
      </div>

      <div className="w-fit self-end">
        {filterBadgesComponent && filterBadgesComponent}
      </div>
    </div>
  );
}